(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/deposit/assets/react/swedbank-express/shared-components/deposit-info.js') >= 0) return;  svs.modules.push('/components/accountservices-react/deposit/assets/react/swedbank-express/shared-components/deposit-info.js');
'use strict';

const DepositInfo = () => React.createElement("p", {
  className: "margin-top-1"
}, "F\xF6r att g\xF6ra en ins\xE4ttning fr\xE5n ditt bankkonto kr\xE4vs en signering med Mobilt BankID.");
svs.accountservicesReact.deposit.swedbankExpress.sharedComponents.DepositInfo = DepositInfo;

 })(window);